/** Languages supported for play (not the UI language list, which is managed by the web app). */
export const LANGS = ['fr', 'en', 'es', 'de', 'it', 'pt'] as const;
export type Lang = (typeof LANGS)[number];

/** Endonyms: languages are shown by name, never reduced to a national flag. */
export const LANG_ENDONYMS: Record<Lang, string> = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  it: 'Italiano',
  pt: 'Português',
};

export function isLang(value: unknown): value is Lang {
  return typeof value === 'string' && (LANGS as readonly string[]).includes(value);
}

/** Canonical ordering used whenever a deterministic order of languages is needed. */
export function sortLangs(langs: readonly Lang[]): Lang[] {
  return [...langs].sort((a, b) => LANGS.indexOf(a) - LANGS.indexOf(b));
}

/** Deduplicates while preserving the player's order. */
export function uniqueLangs(langs: readonly Lang[]): Lang[] {
  const seen = new Set<Lang>();
  const out: Lang[] = [];
  for (const l of langs) {
    if (!seen.has(l)) {
      seen.add(l);
      out.push(l);
    }
  }
  return out;
}
